import DonateAndShareSection from './DonateAndShareSection'
export default DonateAndShareSection
